export const getEnumNamesAndValues = (e) => getEnumNames(e).map((n) => ({ name: n, value: e[n] }));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getEnumNames = (e) => getEnumObjValues(e).filter((v) => typeof v === 'string');
export const getEnumValues = (e) => getEnumObjValues(e).filter((v) => typeof v === 'number');
const getEnumObjValues = (e) => Object.keys(e).map((k) => e[k]);
export const isInEnum = (e, value) => Object.values(e).includes(value);
//# sourceMappingURL=enumHelpers.js.map